const allowedSizeProps = [
	'width',
	'height',
	'maxWidth',
	'maxHeight',
	'minWidth',
	'minHeight',
];

export default allowedSizeProps;